/**
 * TopicView — NodeView for the `topic` node with reorder controls
 * (up arrow, drag handle, down arrow) in the left margin.
 *
 * Mouse path: ReorderControls renders the button trio and
 * delegates the drag to useDragHandle (which attaches a native
 * dragstart listener because React synthetic events fire too
 * late — PM's own dragstart on view.dom has already bubbled
 * past by then).
 *
 * Keyboard path: Alt+↑ / Alt+↓ reaches the same moveNodeUp /
 * moveNodeDown helpers via the Reorder extension registered in
 * TiptapStructuredEditor.
 */
import {
  NodeViewContent,
  NodeViewWrapper,
  type NodeViewProps,
} from '@tiptap/react';
import { ReorderControls } from './ReorderControls.tsx';

export function TopicView({ node, editor, getPos }: NodeViewProps) {
  const key = node.attrs.key;
  return (
    <NodeViewWrapper
      as="section"
      // group/topic carries hover state for ReorderControls; the
      // /row alias is included so generic gutter CSS can match.
      className="tt-topic group/topic group/row relative"
      data-node="topic"
      data-key={key ?? undefined}
    >
      <ReorderControls
        editor={editor}
        getPos={getPos as () => number | undefined}
        label="topic"
        // top-1 nudges the trio down to align with the topic
        // title's baseline (topic titles render with extra top
        // margin via the editor's [&_.tt-topic-title] rules).
        topOffsetClass="top-1"
      />

      <NodeViewContent draggable={false} />
    </NodeViewWrapper>
  );
}
